// Navigation History Service
// Gestisce lo stack di navigazione tra le view

class NavigationHistory {
  constructor() {
    this.history = [];
    this.maxHistorySize = 20; 
  }

  push(viewName, elementId = null, state = {}) {
    const entry = {
      viewName,
      elementId,
      state: { ...state },
      timestamp: Date.now()
    };

    this.history.push(entry);

    if (this.history.length > this.maxHistorySize) {
      this.history.shift();
    }

  }

  pop() {
    const entry = this.history.pop();
    return entry;
  }

  peek() {
    return this.history[this.history.length - 1];
  }


  hasHistory() {
    return this.history.length > 0;
  }


  clear() {
    this.history = [];
  }


  size() {
    return this.history.length;
  }
}


const navigationHistory = new NavigationHistory();

export default navigationHistory;